import { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import Table from "../../../components/Table/Table";
import { useGetTenancyBasicsQuery } from "../../../store/services/tenancy.service";

RoleTable.propTypes = {
    type: PropTypes.string.isRequired,
};

export default function RoleTable({ type, setDepartmentId }) {
    const { tenancyId } = useSelector((state) => state.tenancy);
    const [selected, setSelected] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 100,
        page: 0
    });

    const { data: tenancyData, error: tenancyError, isLoading: tenancyLoading } = useGetTenancyBasicsQuery({
        tenancyId: tenancyId
    });

    let headCells = [
        { id: "role", label: "Role", initialVisible: true },
        { id: "userCount", label: "User Count", initialVisible: true },
    ];

    if (type === "select") {
        headCells.push({
            id: "select",
            label: "Select",
            initialVisible: true,
            render: (dataRow) => (
                <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => setDepartmentId(dataRow.id)}
                    sx={{ textTransform: "capitalize", ml: 1 }}
                >
                    Select
                </Button>
            )
        });
    }

    return (
        <Table
            name={"Roles"}
            data={tenancyData?.roleCounts || []}
            error={tenancyError}
            loading={tenancyLoading}
            headCells={headCells}
            search={false}
            editColumn={false}
            checkbox={false}
            showToolbarActions={false}
            toolbarActions={[]}
            onDelete={() => {}}
            selected={selected}
            setSelected={setSelected}
            maxTableHeight={type === "select" ? "calc(100vh - 500px)" : "calc(100vh - 360px)"}
            initialVisibleColumns={headCells.filter(cell => cell.initialVisible).map(cell => cell.label)}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
        />
    );
}